// React Imports
import * as React from 'react';
import {useEffect, useState} from "react";
import {Controller, useForm} from "react-hook-form";
import {useDispatch, useSelector} from "react-redux";

// Mui Imports
import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';
import Button from '@mui/material/Button';
import {TextField} from "@mui/material";


import {changeCrudSnackbar} from "../../CommonComponents/crudSnackbarSlice";
import {
    getCdpvWithDefault, updateRelatedExpressions
} from "../../ContractDataPointValue/ContractDataPointValueClient";
import {updateCDPV} from "../../ContractDataPoint/ContractDataPointClient";
import {changeWorkQueue} from "../workQueueSlice";
import {refreshContractName} from "../../Contract/ContractClient";
import Stack from "@mui/material/Stack";


import ArrowCircleLeftIcon from "@mui/icons-material/ArrowCircleLeft";
import {changeContractDataPoint} from "../../ContractDataPoint/contractDataPointSlice";
import DynamicCdpvValueField from "../../CommonComponents/DynamicCdpvValueField";
import dayjs from "dayjs";




// Main Function
export default function WorkQueueDrawer(props) {


    // ****************** BEGIN STATES ****************************

    const [submitting, setSubmitting] = useState(false);

    // ****************** END STATES ****************************


    // ****************** BEGIN STORE ****************************

    const dispatchData = useDispatch() ;
    const selectorContractId = useSelector((state) => state.workQueueSlc.value.selectedContractId);
    const selectorCdpId = useSelector((state) => state.workQueueSlc.value.cdpId);
    const selectorDataPointId = useSelector((state) => state.workQueueSlc.value.selectedCdpDataPointId);
    const selectorValue = useSelector((state) => state.workQueueSlc.value.selectedCdpValue);
    // const selectorValue = useSelector((state) => state.workQueueSlc.value.selectedCdpDataType);


    const selectorDataType = useSelector((state) => state.workQueueSlc.value.dataType);


    const selectorInputMissingCount = useSelector((state) => state.workQueueSlc.value.selectedContractInputMissingCount);
    const originalValue = useSelector((state) => state.workQueueSlc.value.selectedCdpOriginalValue);
    const selectorMockOrigin = useSelector((state) => state.workQueueSlc.value.selectedCdpMockOrigin);
    const [selectorDefaultValue, setSelectorDefaultValue] = useState();
    const [selectorDisplayDefaultValue, setSelectorDisplayDefaultValue] = useState();
    const [selectorDefaultValueSource, setSelectorDefaultValueSource] = useState();
    const [selectorDefaultValueDataPoint, setSelectorDefaultValueDataPoint] = useState();
    const [selectorDefaultValueValue, setSelectorDefaultValueValue] = useState();
    const [selectorDisplayDefaultValueValue , setSelectorDisplayDefaultValueValue] = useState();

    // ****************** END STORE ****************************


    // ****************** BEGIN REGISTER ****************************

    const { register, handleSubmit,resetField, setValue,  control, formState: { errors } } = useForm();


    // ****************** END REGISTER ****************************


    // ****************** BEGIN CRUD ****************************

    function onSubmit(data) {
        setSubmitting(true)
        console.log("Submitting an edit of the cdp value in the drawer...")
        console.log("this is my_cdp_id")
        console.log(selectorCdpId)
        console.log("this is my_data_type")
        console.log(selectorDataType)
        console.log("this is my data")
        console.log({data})


            updateCDPV(
                selectorCdpId, selectorDataType,
        selectedDataType === 'DATE' ? dayjs(selectorValue).format('MM/DD/YYYY') : selectorValue
            )
                .then(() => {
                console.log("refreshContractName");
                console.log("selectorContractId", selectorContractId);
                console.log("selectorCdpId", selectorCdpId);
                console.log("selectorValue2", selectedValue2);
                refreshContractName(selectorContractId, selectorCdpId, selectedValue2);
            })

                .then(() => {
                    console.log("ContractDataPointValue edited")
                    console.log("my contract id")
                    console.log(selectorContractId)
                }).catch(err => {
                console.log(err)
                console.log("Error!")

            }).then(() => {
                updateRelatedExpressions(selectorCdpId);
                console.log("update related expression");
                console.log("cdp value = ", selectorValue);
                console.log("cdp mockOrigin = ", selectorMockOrigin);
                console.log("input missing count", selectorInputMissingCount);
            }).then(() => {
        if((originalValue === null || originalValue === '') && (selectorMockOrigin === 'Input')
            && selectorInputMissingCount === 1){
            console.log("auto-advance");
            dispatchData(changeWorkQueue({triggerAdvance: true}));
        }})
                .then(() =>{
                dispatchData(changeWorkQueue({
                    cdpId: 0,
                    dataType: null, value: null, workQueueDrawerState: false, workQueueCDPGridRefresh: true,
                    workQueueNewState: false, workQueueAdvanceState: false, workQueueCDPEditState: true}));
                dispatchData(changeCrudSnackbar({crudOpen: true, crudSeverity: "success", crudMessage: "Record edited"}));
                    // dispatchData(changeWorkQueue({workQueueCGridRefresh: true}));
    }).finally(()=>{
                dispatchData(changeWorkQueue({workQueueCGridRefresh: true}));
        setSubmitting(false)})};



    const handleDefault  = () => {
        console.log("Default Value being pushed.");
        if(selectorDefaultValueSource === 'Value')
        {
            dispatchData(changeWorkQueue({
                selectedCdpValue: selectorDefaultValue }));
            console.log("Default Value coming from fixed Value.");
       }
        if(selectorDefaultValueSource === 'Data Point Value' || selectorDefaultValueSource === 'Data Point')
        {
            dispatchData(changeWorkQueue({
                selectedCdpValue: selectorDefaultValueValue  }));
            console.log("Default Value coming from other Data Point.");
    console.log("selectorDefaultValueValue: ",selectorDefaultValueValue);
            console.log("selectorValue: ",selectorValue);
            }
        console.log(selectorDefaultValue);
    };

    // ****************** END CRUD ****************************


    const fetchCdpvWithDefault = () => {
    if(selectorCdpId > 0){ getCdpvWithDefault(selectorCdpId)

            .then(data => {
                console.log("Default value fetch triggered")
                console.log(data);
                setSelectorDefaultValue(data[0].defaultValue);
                setSelectorDisplayDefaultValue(data[0].displayDefaultValue);
                setSelectorDefaultValueSource(data[0].defaultValueSource);
                setSelectorDefaultValueDataPoint(data[0].defaultValueDataPoint);
                setSelectorDefaultValueValue(data[0].defaultValueValue);
                setSelectorDisplayDefaultValueValue(data[0].displayDefaultValueValue);
                console.log("CdpId ", selectorCdpId);
                console.log("DefaultValue ", selectorDefaultValue);
                console.log("DefaultValueSource ", selectorDefaultValueSource);
                console.log("DefaultValueValue ", selectorDefaultValueValue);
                console.log("DisplayDefaultValueValue ", selectorDisplayDefaultValueValue);
                console.log("selectorDataType ", selectorDataType);
                console.log("selectorDataPointId ", selectorDataPointId);

            })}}
    useEffect(() => {
        console.log("This is for the default value...");
        fetchCdpvWithDefault();
    }, [selectorCdpId]);



    // ****************** END SPECIAL FILTERS ****************************

    // ****************** BEGIN MISC ****************************

    const onFinishFailed = errorInfo => {
        alert(JSON.stringify(errorInfo, null, 2));
    };

    function DefaultArrowDisplay() {
        if (
            (selectorDefaultValue !== '' && selectorDefaultValue !== null &&
                (selectorDefaultValueSource === 'Value' || selectorDefaultValueSource === 'Data Point Value')) ||
            (selectorDefaultValueSource === 'Data Point' && selectorDefaultValueValue !== 'na' &&
                selectorDefaultValueValue !== '' && selectorDefaultValueValue !== null)
        ) {
            return (
                <div className="defaultArrow" onClick={() => handleDefault()} style={{ cursor: 'pointer' }}>
                    <ArrowCircleLeftIcon color="primary" fontSize="large" />
                </div>
            );
        }
        if (
            (selectorDefaultValueValue === '' || selectorDefaultValueValue === 'na' || selectorDefaultValueValue === null) &&
            selectorDefaultValueSource === 'Data Point'
        ) {
            return (
                <div className="defaultArrowError">
                    <ArrowCircleLeftIcon color="error" />
                </div>
            );
        }
        return null; // Return null if no condition matches
    };


    function DefaultValueDisplay() {
        if (
            selectorDefaultValue !== '' && selectorDefaultValue !== undefined
        ) {
            if(selectorDefaultValueSource === 'Value')
            {return (
            <div>
                <TextField id="defaultValue" label="Default Value" variant="outlined"
                           defaultValue={selectorDisplayDefaultValue}
                />

            </div>)
            }
            if(
                (selectorDefaultValueSource === 'Data Point Value' || selectorDefaultValueSource === 'Data Point')
                && ! /Guild/.test(selectorDefaultValue) &&
                (selectorDataType === 'Code' ||
                    selectorDataPointId === 74  || selectorDataPointId === 530   || selectorDataPointId === 532
                    ||  selectorDataPointId === 3557 ||  selectorDataPointId === 3558 ||  selectorDataPointId === 532
                )
            )
            {return (
                <div>
                    <TextField id="defaultValue" label="Default Value" variant="outlined"
                        sx={{width: 300}}
                               defaultValue={selectorDisplayDefaultValueValue}
                    />
                    <p>From: {selectorDefaultValueDataPoint}</p>
                </div>)
            }
            if(
                (selectorDefaultValueSource === 'Data Point Value' || selectorDefaultValueSource === 'Data Point')
                && ! /Guild/.test(selectorDefaultValue)  && selectorDataType !== 'Code'
                && selectorDataPointId !== 74  && selectorDataPointId !== 530   && selectorDataPointId !== 532
                &&  selectorDataPointId !== 3557 &&  selectorDataPointId !== 3558 &&  selectorDataPointId !== 532
            )
            {return (
                <div>
                    <TextField id="defaultValue" label="Default Value" variant="outlined"
                               defaultValue={selectorDisplayDefaultValueValue}
                    />
                    <p>From: {selectorDefaultValueDataPoint}</p>
                </div>)
            }
            if(
                (selectorDefaultValueSource === 'Data Point Value' || selectorDefaultValueSource === 'Data Point')
                && /Guild/.test(selectorDefaultValue)  &&
                (selectorDataType === 'Code' ||
                    selectorDataPointId === 74  || selectorDataPointId === 530   || selectorDataPointId === 532
                ||  selectorDataPointId === 3557 ||  selectorDataPointId === 3558 ||  selectorDataPointId === 532
                )
            )
            {return (
                <div>
                    <TextField id="defaultValue" label="Default Value" variant="outlined"
                               sx={{width: 300}}
                               defaultValue={selectorDisplayDefaultValueValue}
                    />
                    <p>From: {selectorDefaultValueDataPoint}</p>
                    <p>on guild-level contract</p>
                </div>)
            }
            if(
                (selectorDefaultValueSource === 'Data Point Value' || selectorDefaultValueSource === 'Data Point')
                && /Guild/.test(selectorDefaultValue)  && selectorDataType !== 'Code'
                && selectorDataPointId !== 74  && selectorDataPointId !== 530   && selectorDataPointId !== 532
                &&  selectorDataPointId !== 3557 &&  selectorDataPointId !== 3558 &&  selectorDataPointId !== 532
            )
            {return (
                <div>
                    <TextField id="defaultValue" label="Default Value" variant="outlined"
                               defaultValue={selectorDisplayDefaultValueValue}
                    />
                    <p>From: {selectorDefaultValueDataPoint}</p>
                    <p>on guild-level contract</p>
                </div>)
            }
        }
        return null; // Handle cases when selectorDefaultValue is empty or null
    }

    function closeContractDataPointValueDrawer() {
        dispatchData(changeWorkQueue({cdpId: 0, dataType: null, value: null,  workQueueDrawerState: false,
            workQueueNewState: false, workQueueAdvanceState: false}));
    };


    // ****************** END MISC ****************************



    const [selectedValue2, setSelectedValue2] = useState(useSelector((state) => state.workQueueSlc.value.selectedCdpValue));
    const selectedDataType = useSelector((state) => state.workQueueSlc.value.selectedCdpDataType);



    // ****************** BEGIN FORM ****************************

    function contractDataPointValueForm(){

        return(
            <form
                onSubmit={handleSubmit((data)=>        onSubmit(data))}
            >
                <Box
                    sx={{width: 900, height: 300, pl: 5}}
                    role="presentation"
                >
                    <h1 onClick={() => closeContractDataPointValueDrawer()}>Work Queue Form</h1>
                    <h4>Edit Mode</h4>
                    <br/>
                    <br/>
                    <br/>
                    <br/>
                    <h4>{useSelector((state) => state.workQueueSlc.value.selectedCdpDataPointName)}</h4>
                    <br/>
                    <br/>
                    <br/>
<Stack direction="row" spacing={2}>

<Box>
    <DynamicCdpvValueField
        selectorDataPointId={selectorDataPointId}
        selectorValue={selectorValue}
        selectorDataType={selectorDataType}
        selectorContext={"WorkQueueDrawer"}
        selectorLabel={"Value"}
        autoFocus={true}
        control={control}
        fieldName="value"
    />
</Box>
    <Box>
        {/*<br/>*/}
        {/*<br/>*/}
        {/*<br/>*/}
        {/*<br/>*/}
        <DefaultArrowDisplay/>
    </Box>
    <Box>
        {/*<br/>*/}
        {/*<br/>*/}
        {/*<br/>*/}
        <DefaultValueDisplay/>
    </Box>
</Stack>

                    <br/>
                    <br/>
                    <br/>
                    <Button
                        type="submit"
                    >Submit</Button>
                    <Button onClick={() => closeContractDataPointValueDrawer()}>Cancel</Button>
                </Box>
            </form>
        );
    }

    // ****************** END FORM ****************************


    // ****************** BEGIN RETURN ****************************

    return (
        <div>
            <Drawer
                anchor='right'
                open={useSelector((state) => state.workQueueSlc.value.workQueueDrawerState)}
                initialState={{open: false}}
                onClose={closeContractDataPointValueDrawer}
            >
                {contractDataPointValueForm()}

            </Drawer>
        </div>
    );

    // ****************** END RETURN ****************************

}
